.icon {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}
